module.exports = "/_next/static/images/ExtraInfo-41623f3f5a472c2fe7667cd118f01b01.png";